// extracted by mini-css-extract-plugin
export var auto = "_45-1";
export var spinner = "_45-0";